
import * as CorporateBulkCaseRequestAction from './action';
const initialState = {
    fetchBulkRequestsSuccess: {},
    fetchBulkRequestsFailure: {},
    downloadBulkReportRequestTemplateSuccess: {},
    downloadBulkReportRequestTemplateFailure: {},
    submitBulkReportRequestSuccess: {},
    submitBulkReportRequestFailure: {},
    downloadRecordRequestFileSuccess: {},
    downloadRecordRequestFileFailure: {}

}
const CorporateBulkCaseRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case CorporateBulkCaseRequestAction.FETCH_BULK_REPORT_REQUESTS_SUCCESS:
            return state = {
                ...state,
                fetchBulkRequestsSuccess: action.data
            }
        case CorporateBulkCaseRequestAction.FETCH_BULK_REPORT_REQUESTS_FAILURE:
            return state = {
                ...state,
                fetchBulkRequestsFailure: action.error
            }
        case CorporateBulkCaseRequestAction.DOWNLOAD_BULK_REPORT_REQUEST_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                downloadBulkReportRequestTemplateSuccess: action.data
            }
        case CorporateBulkCaseRequestAction.DOWNLOAD_BULK_REPORT_REQUEST_TEMPLATE_FAILURE:
            return state = {
                ...state,
                downloadBulkReportRequestTemplateFailure: action.error
            }
        case CorporateBulkCaseRequestAction.SUBMIT_BULK_REPORT_REQUEST_SUCCESS:
            return state = {
                ...state,
                submitBulkReportRequestSuccess: action.data
            }
        case CorporateBulkCaseRequestAction.SUBMIT_BULK_REPORT_REQUEST_FAILURE:
            return state = {
                ...state,
                submitBulkReportRequestFailure: action.error
            }
        case CorporateBulkCaseRequestAction.DOWNLOAD_RECORD_REQUEST_FILE_SUCCESS:
            return state = {
                ...state,
                downloadRecordRequestFileSuccess: action.data
            }
        case CorporateBulkCaseRequestAction.DOWNLOAD_RECORD_REQUEST_FILE_FAILURE:
            return state = {
                ...state,
                downloadRecordRequestFileFailure: action.error
            }
        default: return state
    }
}

export default CorporateBulkCaseRequestReducer; 